import { SelectionModel } from '@angular/cdk/collections'

export class FixedSelectionModel<T> extends SelectionModel<T> {
    public override deselect(...values: T[]): boolean {
        if (this.compareWith) {
            values.forEach((value) => {
                if (this.isSelected(value)) {
                    const found = this.selected.find(
                        (v) => this.compareWith!(value, v),
                    )
                    if (found) {
                        super.deselect(found)
                    }
                }
            })
            return true
        }

        return super.deselect(...values)
    }
}
